// extracted by mini-css-extract-plugin
module.exports = {"lane":"styles-module__lane___30s1H","hover-border":"styles-module__hover-border___2xkeR"};